import axios from 'axios';

export function errorService(){

    function setError(arg0: string) {
        // throw new Error(arg0);
        console.error(arg0);
    }

    return{
        handleError(message: string, error: unknown){
            // Un 401 est deja traite par l'intercepteur axios (purge + redirection).
            // On ne releve pas d'erreur pour ne pas polluer ni bloquer l'UI.
            if (axios.isAxiosError(error) && error.response?.status === 401) {
                return;
            }
            if (error instanceof Error) {
                setError(`${message} : ${error.message}`)
            } else {
                setError(`${message} : une erreur inconnue s'est produite`)
                
            }
        }
    }
}
